import { Box } from '@chakra-ui/react';
import { useTableCellContext } from '../context';
import StarIcon from '../../../../icons/StarIcon';

const TableCellStarChildren = () => {
  const context = useTableCellContext();

  if (context.cellType === 'star') {
    const { value, dataTestId, justifyContent, ...props } = context;
    const numberFilledStar = value
      ? value <= 0
        ? 0
        : Math.round(value)
      : 0;

    return (
      <Box
        display='flex'
        alignItems='center'
        justifyContent={justifyContent || 'flex-start'}
        height='max-content'
        width='max-content'
        minHeight='max-content'
        borderRadius={0}
        border='none'
        borderWidth={0}
        padding={0}
        margin={0}
        data-testid={dataTestId || 'cjtable-cell-star-id'}
        {...props}
      >
        {[...Array(numberFilledStar).keys()].map((key) => (
          <StarIcon key={`star-${key}`} />
        ))}
        {[...Array(5 - numberFilledStar).keys()].map((key) => (
          <StarIcon key={`star-${5 - key}`} variant='outlined' />
        ))}
      </Box>
    );
  }
  return null;
};

export default TableCellStarChildren;
